import {
    get,
    post,
    upload
} from '@/utils/request'

const SERVICE_URL = '/order-service/v1'

/** ------------------------------ 量产-交货单管理 start ------------------------------ */
export function fetchDeliveryList(params) {
    return post(SERVICE_URL + '/deliveryList/list', params)
}
export function deliveryCountByLoginUser(params) {
    return get(SERVICE_URL + '/deliveryList/deliveryCountByLoginUser', params)
}
export function fetchDeliveryList4Supplier(params) {
    return post(SERVICE_URL + '/deliveryList/list4Supplier', params)
}
export function deleteDelivery(params, pathParam) {
    return post(SERVICE_URL + '/deliveryList/deleteBatch/' + pathParam, params)
}
export function createDelivery(params) {
    return post(SERVICE_URL + '/deliveryList/add', params)
}
export function submitDelivery(params) {
    return post(SERVICE_URL + '/deliveryList/submit', params)
}
export function getDeliveryById(params, pathParam) {
    return get(SERVICE_URL + '/deliveryList/getById', params, pathParam)
}
export function editDelivery(params) {
    return post(SERVICE_URL + '/deliveryList/edit', params)
}
export function passDelivery(params) {
    return post(SERVICE_URL + '/deliveryList/pass', params)
}
export function syncDelivery(params) {
    return post(SERVICE_URL + '/deliveryList/sync-asn', params)
}
export function getAddressList(params) {
    return post(SERVICE_URL + '/deliveryList/getAddressList', params)
}
export function getSupplierList(params) {
    return post(SERVICE_URL + '/deliveryList/getSupplierList', params)
}
export function exportTemplate() {
    return post(SERVICE_URL + '/deliveryList/exportTemplate')
}
/** 交货单批量导出 */
export function exportAsnData(params) {
    return post(SERVICE_URL + '/upload-file/export-asn', params)
}
/** 交货单批量导出 */
export function exportAsnData4Supplier(params) {
    return post(SERVICE_URL + '/upload-file/export-asn-4Supplier', params)
}
/** 交货单导入 */
export function importAsn(params) {
    return upload(SERVICE_URL + '/upload-file/import-asn', params)
}
/** ------------------------------ 量产-交货单管理 end ------------------------------ */


/** ------------------------------ 量产-交货单明细管理 start ------------------------------ */
export function getDeliveryPartList(params) {
    return post(SERVICE_URL + '/deliveryPartList/list', params)
}

export function getAsnContainerDetail(params) {
    return post(SERVICE_URL + '/deliveryPartList/asnContainerDetail', params)
}

export function getPartById(params, pathParam) {
    return get(SERVICE_URL + '/deliveryPartList/getById', params, pathParam)
}

export function saveDeliveryPart(params) {
    return post(SERVICE_URL + '/deliveryPartList/save', params)
}

export function saveDeliveryPartList(params) {
    return post(SERVICE_URL + '/deliveryPartList/saveList', params)
}

export function editDeliveryPart(params) {
    return post(SERVICE_URL + '/deliveryPartList/edit', params)
}

export function createDeliveryPart(params) {
    return post(SERVICE_URL + '/deliveryPartList/add', params)
}

export function createDeliveryPartList(params) {
    return post(SERVICE_URL + '/deliveryPartList/addList', params)
}

export function addeliveryPartList(params) {
    return post(SERVICE_URL + '/deliveryPartList/select-part-list/addList', params)
}

export function closeDeliveryPartList(params) {
    return post(SERVICE_URL + '/deliveryPartList/closeDeliveryPartList', params)
}

export function deletePartList(params, pathParam) {
    return post(SERVICE_URL + '/deliveryPartList/deleteBatch/' + pathParam, params)
}

export function exportDelivery(params) {
    return post(SERVICE_URL + '/deliveryList/export', params)
}

export function printDelivery(params) {
    return post(SERVICE_URL + '/deliveryList/print', params)
}
export function printBoxLabel(params) {
    return post(SERVICE_URL + '/deliveryList/printBoxLabel', params)
}
export function printBoxLabelManager(params) {
    return post(SERVICE_URL + '/deliveryList/printBoxLabelManager', params)
}
/** ------------------------------ 量产-交货单明细管理 end ------------------------------ */


/** ------------------------------ 样件-交货单管理 start ------------------------------ */
export function fetchDeliveryOtsList(params) {
    return post(SERVICE_URL + '/delivery-ots/list-purchase', params)
}
export function fetchDeliveryOtsListBySupplier(params) {
    return post(SERVICE_URL + '/delivery-ots/list-supplier', params)
}
export function createDeliveryOts(params) {
    return post(SERVICE_URL + '/delivery-ots/add-purchase', params)
}
export function createDeliveryOtsBySupplier(params) {
    return post(SERVICE_URL + '/delivery-ots/add-supplier', params)
}
export function updateDeliveryOts(params) {
    return post(SERVICE_URL + '/delivery-ots/update', params)
}
export function submitDeliveryOts(params) {
    return post(SERVICE_URL + '/delivery-ots/submit', params)
}
export function passDeliveryOts(params, pathParam) {
    return post(SERVICE_URL + '/delivery-ots/pass/' + pathParam, params)
}
export function rejectDeliveryOts(params) {
    return post(SERVICE_URL + '/delivery-ots/reject', params)
}
export function closeDeliveryOts(params, pathParam) {
    return post(SERVICE_URL + '/delivery-ots/close/' + pathParam, params)
}
export function deleteDeliveryOts(params, pathParam) {
    return post(SERVICE_URL + '/delivery-ots/delete/' + pathParam, params)
}
export function getDeliveryOtsById(params, pathParam) {
    return get(SERVICE_URL + '/delivery-ots/getById', params, pathParam)
}
export function getOtsSupplierList(params) {
    return get(SERVICE_URL + '/delivery-ots/getSupplierList', params)
}
export function syncOtsDelivery(params) {
    return post(SERVICE_URL + '/delivery-ots/sync/' + params)
}
export function exportASNOtsData(params) {
    return post(SERVICE_URL + '/upload-file/export-asn-ots', params)
}
export function getDeliveryOtsPartList(params) {
    return post(SERVICE_URL + '/delivery-part-ots/list', params)
}
export function addDeliveryOtsPartList(params) {
    return post(SERVICE_URL + '/delivery-part-ots/add', params)
}
export function deleteOtsPartList(params, pathParam) {
    return post(SERVICE_URL + '/delivery-part-ots/delete/' + pathParam, params)
}
export function updateDeliveryOtsPartList(params) {
    return post(SERVICE_URL + '/delivery-part-ots/update', params)
}
export function exportDeliveryOts(params) {
    return post(SERVICE_URL + '/delivery-ots/export', params)
}
export function getAddressListOts(params) {
    return get(SERVICE_URL + '/delivery-ots/getAddressList', params)
}
/** 交货单导入 */
export function importAsnOts(params) {
    return upload(SERVICE_URL + '/upload-file/import-asn-ots', params)
}
/** ------------------------------ 样件-交货单管理 end ------------------------------ */
///deliveryList/saveLoadBill  发运保存
export function saveLoadBill(params) {
    return post(SERVICE_URL + '/deliveryList/saveLoadBill', params)
}